export default __webpack_public_path__ + "static/media/expand.a15f7ab6.svg";